import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom"; // 1. IMPORT THE NECESSARY HOOKS
import { db } from "../../../Firebase_Config/firebaseConfig.js";
import { collection, addDoc } from "firebase/firestore";
import { default as axios } from "axios";
import toast from "react-hot-toast";
import Loader from "../../../Components/Loader/Loader";

const RegistrationForm = ({ page_data }) => {
  // 2. GET THE LOCATION OBJECT TO ACCESS THE PASSED STATE
  const location = useLocation();
  const courseNameFromState = location.state?.courseName;

  const [details, setDetails] = useState({
    fname: "",
    lname: "",
    phone: "",
    email: "",
    studyField: "",
    city: "",
    birthday: "",
    nationality: "",
    credibility: false,
    feesPaid: false,
    courseName: courseNameFromState || "", // 3. ADD courseName TO YOUR STATE
  });

  const data = {
    name: `${details.fname} ${details.lname}`,
    amount: page_data.amount,
    number: `${details.phone}`,
    // MUID: "MUID" + Date.now(),
    // transactionId: "T" + Date.now(),
  };

  const [loading, setLoading] = useState(false);

  // This ensures the course name updates if the user navigates back and forth
  useEffect(() => {
    if (courseNameFromState) {
      setDetails((prev) => ({ ...prev, courseName: courseNameFromState }));
    }
  }, [courseNameFromState]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!details.courseName) {
      toast.error("Course not selected. Please go back and select a course.");
      return;
    }
    setLoading(true);

    try {
      // The 'details' object now correctly includes the courseName
      const docRef = await addDoc(
        collection(db, "course-registration"),
        details
      );

      if (docRef.id) {
        toast.success("Form successfully submitted 🎉");
        console.log("Form submitted successfully");

        const paymentPayload = { ...data, firestoreId: docRef.id };
        console.log("Sending to payment API:", paymentPayload);

        try {
          const paymentResponse = await axios.post(
            "https://phone-pay-payment-gateway-node-js-iota.vercel.app/api/payment",
            paymentPayload
          );

          console.log("Payment API full response:", paymentResponse);

          if (
            paymentResponse.status === 200 &&
            paymentResponse.data?.redirectUrl
          ) {
            window.location.href = paymentResponse.data.redirectUrl;
          } else {
            console.error("Payment failed:", paymentResponse.data);
          }
        } catch (paymentError) {
          console.error(
            "Payment request error:",
            paymentError.response?.data || paymentError.message
          );
        }
      } else {
        console.error("Form submission failed:");
        alert("Form submission failed. Check console for details.");
      }
    } catch (error) {
      console.error("Network or fetch error:", error);
      alert("Network or fetch error. Check console for details.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="course-form">
      <h2>Welcome</h2>
      <p>
        Fill in your correct and UP-TO-DATE details so that we may contact you
        via email on further process
      </p>
      <form onSubmit={handleSubmit}>
        {/* ... other inputs like fname, lname, etc. ... */}
        <div className="student-name">
          <div className="input-wrapper">
            <input
              required
              type="text"
              name="fname"
              id="fname"
              placeholder="Your name"
              value={details.fname}
              onChange={(e) =>
                setDetails((prev) => ({ ...prev, fname: e.target.value }))
              }
            />
            <label htmlFor="fname">
              First Name <span>*</span>
            </label>
          </div>
          <div className="input-wrapper">
            <input
              required
              type="text"
              name="lname"
              id="lname"
              placeholder="Your last name"
              value={details.lname}
              onChange={(e) =>
                setDetails((prev) => ({ ...prev, lname: e.target.value }))
              }
            />
            <label htmlFor="lname">
              Last Name <span>*</span>
            </label>
          </div>
        </div>
        <div className="input-wrapper">
          <input
            required
            type="email"
            name="email"
            id="email"
            placeholder="yourmail@gmail.com"
            value={details.email}
            onChange={(e) =>
              setDetails((prev) => ({ ...prev, email: e.target.value }))
            }
          />
          <label htmlFor="email">
            Email <span>*</span>
          </label>
        </div>
        <div className="input-wrapper">
          <input
            required
            type="text"
            name="phone"
            id="phone"
            value={details.phone}
            onChange={(e) =>
              setDetails((prev) => ({ ...prev, phone: e.target.value }))
            }
          />
          <label htmlFor="phone">
            Phone Number <span>*</span>
          </label>
        </div>

        {/* 4. ADD THIS FIELD TO DISPLAY THE PRE-SELECTED COURSE */}
        <div className="input-wrapper">
          <input
            required
            type="text"
            name="courseName"
            id="courseName"
            value={details.courseName}
            readOnly // This makes it so the user cannot edit the field
            style={{ backgroundColor: "#f0f0f0" }}
          />
          <label htmlFor="courseName">Selected Course</label>
        </div>

        <div className="input-wrapper">
          <input
            required
            type="text"
            name="studyField"
            id="studyField"
            value={details.studyField}
            onChange={(e) =>
              setDetails((prev) => ({ ...prev, studyField: e.target.value }))
            }
          />
          <label htmlFor="studyField">
            Field of Study <span>*</span>
          </label>
        </div>
        <div className="input-wrapper">
          <input
            required
            type="text"
            name="city"
            id="city"
            placeholder="Select city"
            value={details.city}
            onChange={(e) =>
              setDetails((prev) => ({ ...prev, city: e.target.value }))
            }
          />
          <label htmlFor="city">
            City <span>*</span>
          </label>
        </div>
        <div className="input-wrapper">
          <input
            required
            type="date"
            name="birthday"
            id="birthday"
            value={details.birthday}
            onChange={(e) => {
              const val = e.target.value;
              // if user typed invalid year (more than 4 digits)
              const [year] = val.split("-");
              if (year && year.length > 4) return; // stop update
              setDetails((prev) => ({ ...prev, birthday: val }));
            }}
          />
          <label htmlFor="birthday">
            Birthdate <span>*</span>
          </label>
        </div>

        <div className="input-wrapper">
          <input
            required
            type="text"
            name="nationality"
            id="nationality"
            placeholder="Your Nationality"
            value={details.nationality}
            onChange={(e) =>
              setDetails((prev) => ({ ...prev, nationality: e.target.value }))
            }
          />
          <label htmlFor="nationality">
            Nationality <span>*</span>
          </label>
        </div>
        <div className="input-container condition-check">
          <input
            type="checkbox"
            name="credibility"
            required
            id="credibility"
            checked={details.credibility}
            onChange={(e) =>
              setDetails((prev) => ({ ...prev, credibility: e.target.checked }))
            }
          />
          <label htmlFor="credibility">
            I vouch that all the information I have filled above is completely
            true and Proceed to Payment
          </label>
        </div>

        <button type="submit" disabled={loading}>
          {loading ? <Loader /> : `Register @ ${page_data.amount}`}
        </button>
      </form>
    </section>
  );
};

export default RegistrationForm;

// import React, { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom"; // NEW: Import hooks
// import { db } from "../../../Firebase_Config/firebaseConfig.js";
// import { collection, addDoc, updateDoc } from "firebase/firestore";
// import { default as axios } from "axios";
// import toast from "react-hot-toast";
// import Loader from "../../../Components/Loader/Loader";

// const RegistrationForm = ({ page_data }) => {
//   // NEW: Get the location object to access the state passed during navigation
//   const location = useLocation();
//   const courseNameFromState = location.state?.courseName;

//   const [details, setDetails] = useState({
//     fname: "",
//     lname: "",
//     phone: "",
//     email: "",
//     studyField: "",
//     city: "",
//     birthday: "",
//     nationality: "",
//     credibility: false,
//     feesPaid: false,
//     courseName: courseNameFromState || "", // NEW: Initialize state with the course name
//   });

//   const data = {
//     name: `${details.fname} + ${details.lname}`,
//     amount: page_data.amount,
//     number: `${details.phone}`,
//     MUID: "MUID" + Date.now(),
//     transactionId: "T" + Date.now(),
//   };

//   const [loading, setLoading] = useState(false);

//   // Safeguard: Ensures the course name is updated correctly if the user navigates back and forth
//   useEffect(() => {
//     if (courseNameFromState) {
//       setDetails((prev) => ({ ...prev, courseName: courseNameFromState }));
//     }
//   }, [courseNameFromState]);

//   // const makePayment = async (e) => {
//   //   e.preventDefault();

//   //   const transactionid = "Tr-" + uuidv4().toString(36).slice(-6);

//   //   console.log(process.env.MERCHANT_ID);
//   //   const payload = {
//   //     merchantId: "PGTESTPAYUAT",

//   //     // merchantId: "PGTESTPAYUAT",
//   //     merchantTransactionId: transactionid,
//   //     merchantUserId: "MUID-" + uuidv4().toString(36).slice(-6),
//   //     amount: 10000,
//   //     redirectUrl: `http://localhost:3000/api/status/${transactionid}`,
//   //     redirectMode: "POST",
//   //     callbackUrl: `http://localhost:3000/api/status/${transactionid}`,
//   //     mobileNumber: "9999999999",
//   //     paymentInstrument: {
//   //       type: "PAY_PAGE",
//   //     },
//   //   };

//   //   const dataPayload = JSON.stringify(payload);
//   //   console.log(dataPayload);

//   //   // const dataBase64 = Buffer.from(dataPayload).toString("base64");
//   //   const dataBase64 = btoa(dataPayload);

//   //   console.log(dataBase64);

//   //   const fullURL =
//   //     dataBase64 + "/pg/v1/pay" + "099eb0cd-02cf-4e2a-8aca-3e6c6aff0399";
//   //   const dataSha256 = sha256(fullURL);

//   //   const checksum = dataSha256 + "###" + 1;
//   //   console.log("c====", checksum);

//   //   const UAT_PAY_API_URL =
//   //     "https://api-preprod.phonepe.com/apis/pg-sandbox/pg/v1/pay";

//   //   const response = await axios.post(
//   //     UAT_PAY_API_URL,
//   //     {
//   //       request: dataBase64,
//   //     },
//   //     {
//   //       headers: {
//   //         accept: "application/json",
//   //         "Content-Type": "application/json",
//   //         "X-VERIFY": checksum,
//   //       },
//   //     }
//   //   );

//   // const redirect = response.data.data.instrumentResponse.redirectInfo.url;
//   // router.push(redirect)

//   // window.location.href = redirect; //

//   // const options = {
//   //   method: "POST",
//   //   url: UAT_PAY_API_URL,
//   //   headers: {
//   //     accept: "application/json",
//   //     "Content-Type": "application/json",
//   //     "X-VERIFY": checksum,
//   //   },
//   //   data: {
//   //     request: dataBase64,
//   //   },
//   // };

//   // axios
//   //   .request(options)
//   //   .then(function (response) {
//   //     console.log(response.data);
//   //     return response.redirect(
//   //       response.data.data.instrumentResponse.redirectInfo.url
//   //     );
//   //   })
//   //   .catch(function (error) {
//   //     console.error(error);
//   //   });
//   // };

//   const scriptUrl =
//     "https://script.google.com/macros/s/AKfycbyIfoMU3xusqSsNSlhbS3bc09__GWe-c3insKYhHKC6vLf0abzO6qSUawNQ8EvtgUEF/exec";
//   // const scriptUrl =
//   //   "https://script.google.com/macros/s/AKfycbz9QUqi9pxL3zrUjdLgWvZaVaUsV9PKZDfiCV5o5JaVoKvmXKc2VZtDdiSuYBVkD1E5/exec";
//   // const scriptUrl =
//   //   "https://script.google.com/macros/s/AKfycbxRs0TBU2v9IwBGlFCqoU6e1umgglxO83PAmPa-uYlBu6tLe8sBWLxZpeokyzntZow/exec";
//   // const scriptUrl =
//   //   "https://script.google.com/macros/s/AKfycbxojnSqIbdvfVxUIjsn0hWSY6u-DacL78zDBkQJxqOzsvRf8Wf1WCMjlswbJF33Rag/exec";

//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();

//   //   // Handling payment gateway
//   //   axios
//   //     .post("http://localhost:5000/api/payment", {
//   //       ...data,
//   //     })
//   //     // .post("api/payment")
//   //     .then((res) => {
//   //       console.log(res.data);
//   //       window.location.href = res.data;

//   //     })
//   //     .catch((error) => {
//   //       // setLoading2(false);
//   //       console.error(error);
//   //     });

//   //   const formData = new FormData();
//   //   for (const key in details) {
//   //     formData.append(key, details[key]);
//   //   }

//   //   try {
//   //     const response = await fetch(scriptUrl, {
//   //       method: "POST",
//   //       body: formData,
//   //     });

//   //     if (response.ok) {
//   //       // Handle successful response (e.g., show a success message or redirect)
//   //       // setDetails({
//   //       //   fname: "",
//   //       //   lname: "",
//   //       //   phone: "",
//   //       //   email: "",
//   //       //   studyField: "",
//   //       //   city: "",
//   //       //   birthday: "",
//   //       //   nationality: "",
//   //       //   credibility: "",
//   //       // });
//   //       toast.success("Form successfully submitted 🎉");

//   //       console.log("Form submitted successfully");
//   //     } else {
//   //       // Handle error response (e.g., show an error message)
//   //       console.error("Error submitting form");
//   //     }
//   //   } catch (error) {
//   //     // Handle fetch error
//   //     console.error("Error:", error);
//   //   }
//   // };

//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();

//   //   // axios
//   //   //   .post("http://localhost:5000/api/payment", { ...data })
//   //   //   // .post("api/payment")
//   //   //   .then((res) => {
//   //   //     setTimeout(() => {
//   //   //       // setLoading2(false);
//   //   //     }, 1500);
//   //   //   })
//   //   //   .catch((error) => {
//   //   //     // setLoading2(false);
//   //   //     console.error(error);
//   //   //   });

//   //   try {
//   //     // Make a POST request to the payment API
//   //     const paymentResponse = await axios.post(
//   //       "https://valscocoursepaymentservice.onrender.com/api/payment",
//   //       // "https://phone-pay-payment-gateway-node-js.vercel.app/api/payment",
//   //       {
//   //         ...data,
//   //       }
//   //     );

//   //     // If payment request is successful, redirect to the received URL
//   //     if (paymentResponse.status === 200) {
//   //       console.log(paymentResponse.data);
//   //       window.location.href = paymentResponse.data.redirectUrl; // Assuming the server sends back the redirect URL
//   //     } else {
//   //       // Handle payment request error
//   //       const failureUrl = `https://valscotech.com/failure`;
//   //       window.location.href = failureUrl;
//   //       console.error("Payment request failed");
//   //     }
//   //   } catch (paymentError) {
//   //     // Handle payment request error
//   //     const failureUrl = `https://valscotech.com/failure`;
//   //     window.location.href = failureUrl;
//   //     console.error("Payment request error:", paymentError);
//   //   }

//   //   // After handling payment, continue with form submission
//   //   const formData = new FormData();
//   //   for (const key in details) {
//   //     formData.append(key, details[key]);
//   //   }

//   //   try {
//   //     const response = await fetch(scriptUrl, {
//   //       method: "POST",
//   //       body: formData,
//   //     });

//   //     if (response.ok) {
//   //       // Handle successful response (e.g., show a success message or redirect)
//   //       toast.success("Form successfully submitted 🎉");
//   //       console.log("Form submitted successfully");
//   //     } else {
//   //       // Handle error response (e.g., show an error message)
//   //       console.error("Error submitting form");
//   //     }
//   //   } catch (error) {
//   //     // Handle fetch error
//   //     console.error("Error:", error);
//   //   }
//   // };

//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();

//   //   // axios
//   //   //   .post("http://localhost:5000/api/payment", { ...data })
//   //   //   // .post("api/payment")
//   //   //   .then((res) => {
//   //   //     setTimeout(() => {
//   //   //       // setLoading2(false);
//   //   //     }, 1500);
//   //   //   })
//   //   //   .catch((error) => {
//   //   //     // setLoading2(false);
//   //   //     console.error(error);
//   //   //   });

//   //   // After handling payment, continue with form submission
//   //   const formData = new FormData();
//   //   for (const key in details) {
//   //     formData.append(key, details[key]);
//   //   }

//   //   try {
//   //     const response = await fetch(scriptUrl, {
//   //       method: "POST",
//   //       body: formData,
//   //     });

//   //     if (response.ok) {
//   //       // Handle successful response (e.g., show a success message or redirect)
//   //       toast.success("Form successfully submitted 🎉");
//   //       console.log("Form submitted successfully");
//   //     } else {
//   //       // Handle error response (e.g., show an error message)
//   //       console.error("Error submitting form");
//   //     }
//   //   } catch (error) {
//   //     // Handle fetch error
//   //     console.error("Error:", error);
//   //   }

//   //   try {
//   //     // Make a POST request to the payment API
//   //     const paymentResponse = await axios.post(
//   //       "https://valscocoursepaymentservice.onrender.com/api/payment",
//   //       // "https://phone-pay-payment-gateway-node-js.vercel.app/api/payment",
//   //       {
//   //         ...data,
//   //       }
//   //     );

//   //     // If payment request is successful, redirect to the received URL
//   //     if (paymentResponse.status === 200 && paymentResponse.data?.redirectUrl) {
//   //       console.log(paymentResponse.data);
//   //       window.location.href = paymentResponse.data.redirectUrl; // Assuming the server sends back the redirect URL
//   //     } else {
//   //       // Handle payment request error
//   //       const failureUrl = `https://valscotech.com/failure`;
//   //       window.location.href = failureUrl;
//   //       console.error("Payment request failed");
//   //     }
//   //   } catch (paymentError) {
//   //     // Handle payment request error
//   //     const failureUrl = `https://valscotech.com/failure`;
//   //     window.location.href = failureUrl;
//   //     console.error("Payment request error:", paymentError);
//   //   }
//   // };

//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();

//   //   // axios
//   //   //   .post("http://localhost:5000/api/payment", { ...data })
//   //   //   // .post("api/payment")
//   //   //   .then((res) => {
//   //   //     setTimeout(() => {
//   //   //       // setLoading2(false);
//   //   //     }, 1500);
//   //   //   })
//   //   //   .catch((error) => {
//   //   //     // setLoading2(false);
//   //   //     console.error(error);
//   //   //   });

//   //   // Prepare form data
//   //   const formData = new FormData();
//   //   for (const key in details) {
//   //     formData.append(key, details[key]);
//   //   }

//   //   try {
//   //     // First: submit form
//   //     const response = await fetch(scriptUrl, {
//   //       method: "POST",
//   //       body: formData,
//   //     });

//   //     if (response.ok) {
//   //       // ✅ Form submission succeeded
//   //       toast.success("Form successfully submitted 🎉");
//   //       console.log("Form submitted successfully");

//   //       // try {
//   //       //   // Second: initiate payment
//   //       //   const paymentResponse = await axios.post(
//   //       //     "https://valscocoursepaymentservice.onrender.com/api/payment",
//   //       //     {
//   //       //       ...data,
//   //       //     }
//   //       //   );

//   //       //   if (
//   //       //     paymentResponse.status === 200 &&
//   //       //     paymentResponse.data?.redirectUrl
//   //       //   ) {
//   //       //     console.log(paymentResponse.data);
//   //       //     window.location.href = paymentResponse.data.redirectUrl;
//   //       //   } else {
//   //       //     const failureUrl = `https://valscotech.com/failure`;
//   //       //     window.location.href = failureUrl;
//   //       //     console.error("Payment request failed");
//   //       //   }
//   //       // } catch (paymentError) {
//   //       //   const failureUrl = `https://valscotech.com/failure`;
//   //       //   window.location.href = failureUrl;
//   //       //   console.error("Payment request error:", paymentError);
//   //       // }
//   //       try {
//   //         const paymentResponse = await axios.post(
//   //           "https://valscocoursepaymentservice.onrender.com/api/payment",
//   //           { ...data }
//   //         );

//   //         console.log("Payment API raw response:", paymentResponse);

//   //         if (
//   //           paymentResponse.status === 200 &&
//   //           paymentResponse.data?.redirectUrl
//   //         ) {
//   //           alert("Payment URL: " + paymentResponse.data.redirectUrl); // Debug
//   //           window.location.href = paymentResponse.data.redirectUrl;
//   //         } else {
//   //           console.error("Payment failed:", paymentResponse.data);
//   //           alert("Payment failed, check console");
//   //         }
//   //       } catch (paymentError) {
//   //         console.error("Payment request error:", paymentError);
//   //         alert("Payment request error, check console");
//   //       }
//   //     } else {
//   //       // ❌ Form submission failed
//   //       console.error("Error submitting form");
//   //     }
//   //   } catch (error) {
//   //     // ❌ Network or other error
//   //     console.error("Error:", error);
//   //   }
//   // };
//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();
//   //   setLoading(true);

//   //   // 1️⃣ Prepare FormData for Google Script
//   //   const formData = new FormData();
//   //   for (const key in details) {
//   //     formData.append(key, details[key]);
//   //   }

//   //   try {
//   //     // 2️⃣ Submit the form to Google Script
//   //     const formResponse = await fetch(scriptUrl, {
//   //       method: "POST",
//   //       body: formData,
//   //     });

//   //     if (!formResponse.ok) {
//   //       console.error(
//   //         "Form submission failed:",
//   //         formResponse.status,
//   //         formResponse.statusText
//   //       );
//   //       alert("Form submission failed. Check console.");
//   //       setLoading(false);
//   //       return;
//   //     }

//   //     toast.success("Form submitted successfully 🎉");
//   //     console.log("Form submitted successfully");

//   //     // 3️⃣ Prepare payment payload
//   //     const paymentPayload = {
//   //       name: `${details.fname} ${details.lname}`,
//   //       amount: page_data.amount, // rupees, backend will convert to paise
//   //       number: details.phone,
//   //     };
//   //     console.log("Sending to payment API:", paymentPayload);

//   //     // 4️⃣ Call your backend /api/payment
//   //     const paymentResponse = await axios.post(
//   //       "https://valscocoursepaymentservice.onrender.com/api/payment",
//   //       paymentPayload
//   //     );

//   //     if (paymentResponse.status === 200 && paymentResponse.data?.redirectUrl) {
//   //       // ✅ Redirect user to PhonePe payment page
//   //       console.log("Redirecting to:", paymentResponse.data.redirectUrl);
//   //       window.location.href = paymentResponse.data.redirectUrl;
//   //     } else {
//   //       console.error("Payment failed:", paymentResponse.data);
//   //       alert("Payment failed. Check console.");
//   //     }
//   //   } catch (error) {
//   //     console.error(
//   //       "Error during submission/payment:",
//   //       error.response?.data || error.message
//   //     );
//   //     alert("Submission or payment failed. Check console.");
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     // Prepare FormData for Google Script
//     // const formData = new FormData();
//     // for (const key in details) {
//     //   formData.append(key, details[key]);
//     // }

//     try {
//       const docRef = await addDoc(
//         collection(db, "course-registration"),
//         details
//       );

//       // 1️⃣ Submit the form to Google Script
//       // const response = await fetch(scriptUrl, {
//       //   method: "POST",
//       //   body: formData,
//       // });

//       if (docRef.id) {
//         toast.success("Form successfully submitted 🎉");
//         console.log("Form submitted successfully");

//         // 2️⃣ Prepare payment data
//         const paymentPayload = { ...data };
//         console.log("Sending to payment API:", paymentPayload);

//         try {
//           // 3️⃣ Call the payment API
//           const paymentResponse = await axios.post(
//             "https://phone-pay-payment-gateway-node-js.vercel.app/api/payment",
//             paymentPayload
//           );

//           // 4️⃣ Log full response for debugging
//           console.log("Payment API full response:", paymentResponse);

//           if (
//             paymentResponse.status === 200 &&
//             paymentResponse.data?.redirectUrl
//           ) {
//             // alert("Payment URL: " + paymentResponse.data.redirectUrl); // Debug
//             // await updateDoc(docRef, {
//             //   feesPaid: true,
//             // });
//             window.location.href = paymentResponse.data.redirectUrl;
//           } else {
//             console.error("Payment failed:", paymentResponse.data);
//             // alert("Payment failed. Check console for details.");
//           }
//         } catch (paymentError) {
//           // Log full error info
//           console.error(
//             "Payment request error:",
//             paymentError.response?.data || paymentError.message
//           );
//           // alert("Payment request error. Check console for details.");
//         }
//       } else {
//         console.error(
//           "Form submission failed:"
//           // response.status,
//           // response.statusText
//         );
//         alert("Form submission failed. Check console for details.");
//       }
//     } catch (error) {
//       console.error("Network or fetch error:", error);
//       alert("Network or fetch error. Check console for details.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <section className="course-form">
//       <h2>Welcome</h2>
//       <p>
//         Fill in your correct and UP-TO-DATE details so that we may contact you
//         via email on further process
//       </p>
//       <form onSubmit={handleSubmit}>
//         <div className="student-name">
//           <div className="input-wrapper">
//             <input
//               required
//               type="text"
//               name="fname"
//               id="fname"
//               placeholder="Your name"
//               value={details.fname}
//               onChange={(e) =>
//                 setDetails((prev) => {
//                   return { ...prev, fname: e.target.value };
//                 })
//               }
//             />
//             <label htmlFor="fname">
//               First Name <span>*</span>
//             </label>
//           </div>
//           <div className="input-wrapper">
//             <input
//               required
//               type="text"
//               name="lname"
//               id="lname"
//               placeholder="Your last name"
//               value={details.lname}
//               onChange={(e) =>
//                 setDetails((prev) => {
//                   return { ...prev, lname: e.target.value };
//                 })
//               }
//             />
//             <label htmlFor="lname">
//               Last Name <span>*</span>
//             </label>
//           </div>
//         </div>
//         <div className="input-wrapper">
//           <input
//             required
//             type="email"
//             name="email"
//             id="email"
//             placeholder="yourmail@gmail.com"
//             value={details.email}
//             onChange={(e) =>
//               setDetails((prev) => {
//                 return { ...prev, email: e.target.value };
//               })
//             }
//           />
//           <label htmlFor="email">
//             Email <span>*</span>
//           </label>
//         </div>
//         <div className="input-wrapper">
//           <input
//             required
//             type="text"
//             name="phone"
//             id="phone"
//             value={details.phone}
//             onChange={(e) =>
//               setDetails((prev) => {
//                 return { ...prev, phone: e.target.value };
//               })
//             }
//           />
//           <label htmlFor="studyField">
//             Phone Number <span>*</span>
//           </label>
//         </div>
//         <div className="input-wrapper">
//           <input
//             required
//             type="text"
//             name="studyField"
//             id="studyField"
//             value={details.studyField}
//             onChange={(e) =>
//               setDetails((prev) => {
//                 return { ...prev, studyField: e.target.value };
//               })
//             }
//           />
//           <label htmlFor="studyField">
//             Field of Study <span>*</span>
//           </label>
//         </div>
//         <div className="input-wrapper">
//           <input
//             required
//             type="text"
//             name="city"
//             id="city"
//             placeholder="Select city"
//             value={details.city}
//             onChange={(e) =>
//               setDetails((prev) => {
//                 return { ...prev, city: e.target.value };
//               })
//             }
//           />
//           <label htmlFor="city">
//             City <span>*</span>
//           </label>
//         </div>
//         <div className="input-wrapper">
//           <input
//             required
//             type="date"
//             name="birthday"
//             id="birthday"
//             value={details.birthday}
//             onChange={(e) =>
//               setDetails((prev) => {
//                 return { ...prev, birthday: e.target.value };
//               })
//             }
//           />
//           <label htmlFor="birthday">
//             Birthdate <span>*</span>
//           </label>
//         </div>
//         <div className="input-wrapper">
//           <input
//             required
//             type="text"
//             name="nationality"
//             id="nationality"
//             placeholder="Your Nationality"
//             value={details.nationality}
//             onChange={(e) =>
//               setDetails((prev) => {
//                 return { ...prev, nationality: e.target.value };
//               })
//             }
//           />
//           <label htmlFor="nationality">
//             Nationality <span>*</span>
//           </label>
//         </div>
//         <div className="input-container condition-check">
//           <input
//             type="checkbox"
//             name="credibility"
//             required
//             id="credibility"
//             checked={details.credibility}
//             onChange={(e) =>
//               setDetails((prev) => ({ ...prev, credibility: e.target.checked }))
//             }
//           />
//           <label htmlFor="credibility">
//             I vouch that all the information I have filled above is completely
//             true and Proceed to Payment
//           </label>
//         </div>

//         <button type="submit" disabled={loading}>
//           {loading ? <Loader /> : `Register @ ${page_data.amount}`}
//         </button>
//       </form>
//     </section>
//   );
// };

// export default RegistrationForm;
